module.exports = "../../../../platform/assets/pageMainIcon/ig-business-setting-3.svg";